import { HStack, VStack, Text, DataList, DataItem } from '@cad-arc';
import { UnitStatusSearchRow } from '@mark43/cad-api';
import { ExpandableContent } from './expandable-content';

export function UnitStatusSearchResultsUnitCell({
    row,
    isExpanded,
}: {
    row: UnitStatusSearchRow;
    isExpanded: boolean;
}) {
    return (
        <VStack align="left" gap={isExpanded ? '8px' : undefined}>
            <HStack>
                <Text>{row.callSign}</Text>
                {row.subdivisions && <Text color="tertiary">{row.subdivisions}</Text>}
            </HStack>
            <ExpandableContent isExpanded={isExpanded}>
                <VStack align="left">
                    {row.members.map((member) => (
                        <Text key={member}>{member}</Text>
                    ))}
                </VStack>
                {row.vehicleTag && (
                    <DataList>
                        <DataItem dataKey="Plate">{row.vehicleTag}</DataItem>
                    </DataList>
                )}
            </ExpandableContent>
        </VStack>
    );
}
